
// Purpose: Utility functions for auth state cleanup, session token validation, and protected route detection.

import { supabase } from '@/integrations/supabase/client';
import { Session } from '@supabase/supabase-js';
import { PROTECTED_ROUTES } from './authConstants';

// Remove authentication tokens and related keys from storage.
export const cleanupAuthState = () => {
  localStorage.removeItem('supabase.auth.token');
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      localStorage.removeItem(key);
    }
  });
  Object.keys(sessionStorage || {}).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      sessionStorage.removeItem(key);
    }
  });
};

// Returns true if user is on a protected route.
export const isOnProtectedRoute = () => {
  const currentPath = window.location.pathname;
  return PROTECTED_ROUTES.some(route => currentPath.startsWith(route));
};

// Checks if the current session token is valid (safe for multi-context).
export const validateSessionToken = async (currentSession: Session | null) => {
  if (!currentSession || !isOnProtectedRoute()) {
    return true;
  }

  try {
    // Only check local session validity — avoid network calls that can fail transiently
    const { data, error: sessionError } = await supabase.auth.getSession();
    if (sessionError || !data?.session) {
      console.log('Session check failed:', sessionError?.message || 'No session');
      return false;
    }
    return true;
  } catch (error) {
    console.log('Session validation error:', error);
    // Don't invalidate on transient errors
    return true;
  }
};
